import type { Customer } from '@/lib/api/customer-api'
import { m } from '@/lib/paraglide/messages'

export const APP_NAME = m.app_name()

export const ROUTES = {
    LOGIN: '/login',
    DASHBOARD: '/',
} as const

// Default shipping carrier id: the seeded "Tự giao" (self-delivery) row in
// shipping_carriers. Sent to the backend when no carrier is explicitly picked.
// Kept in sync with the migration that seeds this fixed id.
export const DEFAULT_SHIPPING_CARRIER_ID =
    '00000000-0000-0000-0000-000000000001'

export const WALKIN_CUSTOMER_ID = '00000000-0000-0000-0000-000000000001'

// WALKIN_CUSTOMER name/address are sent verbatim to the backend API as
// customer data — they are data values, not UI display strings.
export const WALKIN_CUSTOMER: Customer = {
    id: WALKIN_CUSTOMER_ID,
    code: 'KL-000',
    // eslint-disable-next-line hd-local/no-hardcoded-vietnamese
    name: 'Khách lẻ',
    phone: '0000000000',
    // eslint-disable-next-line hd-local/no-hardcoded-vietnamese
    address: 'Khách vãng lai',
    credit_limit: 0,
    is_active: true,
    created_at: '',
    updated_at: '',
}

export function isWalkInCustomer(
    customer: Pick<Customer, 'id'> | null | undefined,
): boolean {
    return customer?.id === WALKIN_CUSTOMER_ID
}
